export class StakeInputParser {
    /*  This is a function to convert a localized number to valid javascript format for parsing.
        For example, English sites use "." as a separator.
        Portuguese sites use "," as a separator.

        Depending on count of decimal separators the behavior changes.

        For any settings:
        - We ignore all symbols except numbers, points and commas.
        - If more than two decimal separators - number is invalid, return 0.

        If DecimalSeparators = ["."]
        - Ignore all ","

        For DecimalSeparators = [","]
        - Ignore all "."

        For DecimalSeparators = [".", ","]
        - "," and "." using as decimal separator.

        Behavior may not be changed without the approval of the Product Owner.
     */
    private decimalSplitRegExp: RegExp;
    private clearInputChecks: RegExp[];
    private numberFormat: Intl.NumberFormat;

    constructor(decimalSeparators: string[], numberFormat: Intl.NumberFormat) {
        this.clearInputChecks = decimalSeparators.map(s => {
            var thSeparator = s === "." ? "," :".";
            return new RegExp(`^([0-9]{1,})?(([0-9]{1,3}(\\${thSeparator}[0-9]{3})*)?\\${s}[0-9]{0,2})?$`);
        });
        let separators = decimalSeparators.join("");
        this.decimalSplitRegExp = new RegExp(`[${separators}](?![0-9]{3}[${separators}])`);
        this.numberFormat = numberFormat;
    }

    public parse(value: string) : number {
        return parseFloat(this.getClearedNumberValue(value));
    }

    public getValueForRedraw(value: string, deposit: number): string {
        var isCorrectInput = this.clearInputChecks.some(r => value.match(r) !== null);
        if (!isCorrectInput || this.parse(value) !== deposit) {
            return this.numberFormat.format(deposit);
        }
        return value;
    }

    private getClearedNumberValue(value: string): string {
        return value && this.convertToStandardNumberString(this.removeExtraLetters(value)) || "0";
    }

    private convertToStandardNumberString(value: string) : string {
        let decimalSplitMatch = value.match(this.decimalSplitRegExp);
        if (decimalSplitMatch === null) {
            return this.clearIntegerNumberString(value);
        } else {
            return this.parseFloatingPointNumberString(decimalSplitMatch[0], value);
        }
    }

    private clearIntegerNumberString(value: string ): string {
        return value.replace(/[.,]/g, "");
    }

    private parseFloatingPointNumberString(separator: string, result: string) {
        let index = result.indexOf(separator);
        let leftPart = result.substr(0, index) || "0";
        let rightPart = result.substr(index + 1);
        let thousandSeparator = separator === "." ? /,/g : /\./g;
        return `${leftPart.replace(thousandSeparator, "")}.${rightPart.replace(/[.,]/g, "")}`;
    }

    private removeExtraLetters(value: string) {
        return value.replace(/(?![,.])\D/g, "");
    }
}